import type { AnalyticsServiceConfig, IAnalyticsService } from '../analytics';
import { AnalyticsService } from '../analytics';

type Article = {
  id: number;
};

type CommentClickHandlerParams = {
  event: Event;
  articleId: number;
};

enum ActionType {
  View = 'Просмотр',
  Click = 'Клик',
}

export interface ITopArticlesBlockAnalyticsService extends IAnalyticsService {
  sendEventArticleClick(articleId: number): void;
  sendEventCommentClick(event: CommentClickHandlerParams): void;
  sendEventBlockShown(items: Article[]): void;
}

export type TopArticlesBlockAnalyticsServiceConfig = AnalyticsServiceConfig;

export class TopArticlesBlockAnalyticsService extends AnalyticsService {
  private readonly _oldBlockName = 'ТОП5 (блок)';
  private readonly _newBlockName = 'ТОП 5';

  constructor(config: TopArticlesBlockAnalyticsServiceConfig) {
    super(config);
  }

  public sendEventArticleClick(articleId: number): void {
    this._sendClickedLinkRG('Переход на материал', articleId, 'Материал');
  }

  public sendEventCommentClick({ articleId }: CommentClickHandlerParams): void {
    this._sendClickedLinkRG('Переход на комментарии', articleId, 'Комментарий');
  }

  public sendEventBlockShown(items: Article[]): void {
    const ids = items.map((item) => item.id).join(', ') ?? '';

    this.analytics.send({
      event: {
        pageName: this.pageName,
        blockType: this.blockPlace,
        fieldType: this._oldBlockName,
        goalName: 'viewTopPopularBlock',
        valueName: ActionType.View,
      },
    });

    this.analytics.send({
      event: {
        pageName: this.pageName,
        blockType: this._newBlockName,
        actionType: ActionType.View,
        goalName: 'ViewTOP5',
        prop1: ids,
      },
    });
  }

  private _sendClickedLinkRG(value: string, articleId: number, place: string) {
    this.analytics.send({
      event: {
        pageName: this.pageName,
        blockType: this.blockPlace,
        fieldType: this._oldBlockName,
        goalName: 'clickTopPopularBlock',
        valueName: value,
      },
    });

    this.analytics.send({
      event: {
        pageName: this.pageName,
        blockType: this._newBlockName,
        actionType: ActionType.Click,
        goalName: 'clickTopPopularBlock',
        prop1: `${articleId}`,
        prop2: place,
      },
    });
  }
}
